const PLAIN_IDENTIFIER_KEY = /^[a-z][a-z0-9_]*$/i;

export function appendObjectKey(args: { path: string; key: string }): string {
  const { path, key } = args;
  if (PLAIN_IDENTIFIER_KEY.test(key)) {
    return `${path}.${key}`;
  }
  return `${path}[${JSON.stringify(key)}]`;
}

export function appendArrayIndex(args: { path: string; index: number }): string {
  const { path, index } = args;
  return `${path}[${index}]`;
}
